export const getRowClassName = () => 'sts-row';
